import * as BREAKPOINTS from '@zola/zola-ui/src/lib/ui/breakpoints';
import { ImageType } from 'libs/client/Image/getSourceElements';

import ClassicDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/classic_desktop.jpg';
import ClassicTablet from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/classic_tablet.jpg';
import ClassicMobile from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/classic_mobile.jpg';
import ClassicDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/classic_desktop.webp';
import ClassicTabletWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/classic_tablet.webp';
import ClassicMobileWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/classic_mobile.webp';

import PremierDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/premier_desktop.jpg';
import PremierTablet from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/premier_tablet.jpg';
import PremierMobile from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/premier_mobile.jpg';
import PremierDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/premier_desktop.webp';
import PremierTabletWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/premier_tablet.webp';
import PremierMobileWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/premier_mobile.webp';

import DeluxeDesktop from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/deluxe_desktop.jpg';
import DeluxeTablet from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/deluxe_tablet.jpg';
import DeluxeMobile from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/deluxe_mobile.jpg';
import DeluxeDesktopWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/deluxe_desktop.webp';
import DeluxeTabletWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/deluxe_tablet.webp';
import DeluxeMobileWebp from '../../../../../public/static-preauth/images/WeddingAlbums/categoryTiles/deluxe_mobile.webp';

const classicAlbumImages: ImageType = {
  webp: [
    { url: ClassicMobileWebp, maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString() },
    { url: ClassicTabletWebp, maxBreakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString() },
    { url: ClassicDesktopWebp, minBreakpoint: BREAKPOINTS.SCREEN_MD.toString() },
  ],
  jpg: [
    { url: ClassicMobile, maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString() },
    { url: ClassicTablet, maxBreakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString() },
    { url: ClassicDesktop, minBreakpoint: BREAKPOINTS.SCREEN_MD.toString() },
  ],
};

const premierAlbumImages: ImageType = {
  webp: [
    { url: PremierMobileWebp, maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString() },
    { url: PremierTabletWebp, maxBreakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString() },
    { url: PremierDesktopWebp, minBreakpoint: BREAKPOINTS.SCREEN_MD.toString() },
  ],
  jpg: [
    { url: PremierMobile, maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString() },
    { url: PremierTablet, maxBreakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString() },
    { url: PremierDesktop, minBreakpoint: BREAKPOINTS.SCREEN_MD.toString() },
  ],
};

const deluxeAlbumImages: ImageType = {
  webp: [
    { url: DeluxeMobileWebp, maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString() },
    { url: DeluxeTabletWebp, maxBreakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString() },
    { url: DeluxeDesktopWebp, minBreakpoint: BREAKPOINTS.SCREEN_MD.toString() },
  ],
  jpg: [
    { url: DeluxeMobile, maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString() },
    { url: DeluxeTablet, maxBreakpoint: BREAKPOINTS.SCREEN_SM_MAX.toString() },
    { url: DeluxeDesktop, minBreakpoint: BREAKPOINTS.SCREEN_MD.toString() },
  ],
};

export const albumImages = {
  classic: classicAlbumImages,
  classicFeaturedSrc: ClassicDesktop,
  premier: premierAlbumImages,
  premierFeaturedSrc: PremierDesktop,
  deluxe: deluxeAlbumImages,
  deluxeFeaturedSrc: DeluxeDesktop,
};
